// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Conversación',
  working: 'Pensando…',
  stopped: 'Detenido. No se ha cambiado nada.',
  step_stopped: 'Detenido',
  steps_completed_one: '{{count}} paso completado',
  steps_completed_other: '{{count}} pasos completados',
  chart: {
    table: 'Las cifras de este gráfico',
    label: 'Etiqueta',
    value: 'Valor',
  },
  // A form of several values Amigo needs at once (ask_form, contracts §5).
  form: {
    submit: 'Continuar',
    skip: 'Omitir por ahora',
    required: 'Rellena esto para continuar',
    generated: 'Se crea para ti al aprobar',
    step_of: 'Paso {{index}} de {{total}}',
    on: 'Activado',
    off: 'Desactivado',
    skipped: 'Omitido por ahora',
  },
  next_steps: 'Siguientes pasos',
  action_card: {
    select_restaurant: 'Seleccionar este restaurante',
    open_page: 'Se abre en el panel',
  },
  not_sent: 'No enviado',
  failed: {
    text: 'Algo ha fallado por mi parte, así que no se ha cambiado nada. Inténtalo de nuevo en un momento.',
    retry: 'Reintentar',
  },
  question: {
    other: 'Otra opción…',
    send: 'Enviar',
    label: 'Pregunta',
    type_answer: '¿Otra opción? Escríbela abajo.',
    label_many: 'Preguntas',
    step_of: '{{index}} de {{total}}',
    previous: 'Pregunta anterior',
    next: 'Pregunta siguiente',
    dismiss: 'Ahora no',
  },
  unavailable: {
    title: {
      amigo: 'Amigo no está disponible en este momento.',
      assistant: 'El asistente no está disponible en este momento.',
    },
    text: 'No se ha cambiado nada y el resto del panel funciona con normalidad. Inténtalo de nuevo en unos minutos.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Hoy',
  when: {
    today: 'Hoy, {{time}}',
    yesterday: 'Ayer, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line: 'Nuevo chat para {{restaurant}}. Los chats de {{previous}} están en Chats cuando vuelvas a él.',
  // A restaurant selected during a chat with no restaurant selected (D18): the chat carries on there, or a new one starts.
  carried_on_line: 'Ahora en {{restaurant}}. Este chat continúa y se guarda con sus chats.',
  from_none_line:
    'Nuevo chat para {{restaurant}}. Tu chat sobre {{earlier}} está en Chats, sin restaurante seleccionado.',
  from_none_line_unnamed:
    'Nuevo chat para {{restaurant}}. Tu chat anterior está en Chats, sin restaurante seleccionado.',
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: 'Chat de {{name}} (FoodAmigos)',
      owner: 'Chat de {{name}} (propietario)',
      staff: 'Chat de {{name}} (personal)',
      partner: 'Chat de {{name}} (socio)',
      other: 'Chat de {{name}}',
      unnamed: 'Chat de otra persona',
    },
    text: 'Chat de {{name}}. Puedes leerlo, pero no responder ni aprobar sus tarjetas.',
    text_unnamed: 'Chat de otra persona. Puedes leerlo, pero no responder ni aprobar sus tarjetas.',
    new_chat: 'Nuevo chat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'Este chat ha finalizado. Inicia un chat nuevo para continuar.',
    new_chat: 'Nuevo chat',
    moved_line: 'Nuevo chat, porque el anterior había terminado',
  },
  composer: {
    label: 'Mensaje',
    placeholder: 'Haz una pregunta o describe un cambio',
    placeholder_answer: 'Escribe tu respuesta',
    hint: 'Intro para enviar · Mayús+Intro para nueva línea',
  },
  table: {
    show_all: 'Mostrar las {{count}} filas',
    show_fewer: 'Mostrar menos',
  },
  steps: {
    areas: 'Comprobando en qué puedo ayudar aquí',
    area_describe: 'Revisando {{area}}',
    restaurants: 'Buscando el restaurante',
    read: 'Leyendo tus datos',
    propose: 'Preparando el cambio',
    change_set_get: 'Comprobando el cambio',
    change_set_undo: 'Preparando la anulación',
    change_set_withdraw: 'Cerrando la tarjeta',
    gap_record: 'Anotándolo para nuestro equipo',
    research: 'Buscando cómo funciona esto',
    screen_find: 'Buscando la página correcta',
    file_read: 'Leyendo tu archivo',
    attach_chat_file: 'Preparando tu archivo',
    shop_check: 'Comprobando tu tienda',
    area_describe_other: 'Revisando esta área',
    other: 'Comprobando algo',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    restaurants: {
      other: 'No se encontró el restaurante',
    },
    read: {
      menu: 'No se pudo leer el menú',
      hours: 'No se pudo leer el horario de apertura',
      order_settings: 'No se pudieron leer los ajustes de pedidos',
      my_info: 'No se pudieron leer tus datos',
      marketing: 'No se pudo leer tu marketing',
      gift_cards: 'No se pudieron leer las tarjetas regalo',
      reports: 'No se pudieron leer tus cifras',
      other: 'No se pudieron leer tus datos',
    },
    propose: {
      menu: 'No se pudo preparar el cambio del menú',
      hours: 'No se pudo preparar el cambio del horario de apertura',
      order_settings: 'No se pudo preparar el cambio de los ajustes de pedidos',
      my_info: 'No se pudo preparar el cambio de tus datos',
      marketing: 'No se pudo preparar el cambio de marketing',
      gift_cards: 'No se pudo preparar el cambio de las tarjetas regalo',
      other: 'No se pudo preparar el cambio',
    },
    change_set_get: { other: 'No se pudo comprobar el cambio' },
    change_set_undo: { other: 'No se pudo preparar la anulación' },
    change_set_withdraw: { other: 'No se pudo cerrar la tarjeta' },
    research: { other: 'No se pudo consultar cómo funciona esto' },
    screen_find: { other: 'No se pudo encontrar la página' },
    file_read: { other: 'No se pudo leer tu archivo' },
    attach_chat_file: { other: 'No se pudo preparar tu archivo' },
    shop_check: { other: 'No se pudo abrir tu tienda' },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'el menú',
    hours: 'el horario',
    order_settings: 'los ajustes de pedidos',
    my_info: 'la información de tu restaurante',
    marketing: 'el marketing',
    reports: 'los informes',
  },
};
